import { FC } from 'react'
import styles from './LoadingComponent.module.scss'

const LoadingComponent: FC = () => {
  return (
    <div className={styles.loading}>
      <div className={styles.loadingObject}>
        <img src="/service_icon.webp" alt="Loading" />
      </div>
    </div>
  )
}

export default LoadingComponent
